import { Check } from "lucide-react";

const PLANS = [
  { amount: "$5,000",  starting: "$8",  desc: "Essential burial coverage for basic funeral expenses.", popular: false },
  { amount: "$10,000", starting: "$15", desc: "Covers a traditional funeral, headstone, and small debts.", popular: false },
  { amount: "$15,000", starting: "$22", desc: "Funeral expenses plus a financial cushion for loved ones.", popular: true  },
  { amount: "$20,000", starting: "$29", desc: "Comprehensive coverage including outstanding medical bills.", popular: false },
  { amount: "$25,000", starting: "$36", desc: "Maximum legacy protection for your family's future.", popular: false },
];

const FEATURES = [
  "Guaranteed acceptance ages 50-85",
  "No medical exam required",
  "Locked-in rates for life",
  "Death benefit never decreases",
  "Coverage as soon as 24 hours",
];

export default function CoveragePlans() {
  return (
    <section id="plans" className="py-20 lg:py-28 bg-white paper-bg" data-testid="plans-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <p className="text-xs sm:text-sm uppercase tracking-[0.22em] text-gold-deep font-semibold">Coverage Plans</p>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-navy leading-tight mt-3">
            Plans Tailored To Every Budget &amp; Family.
          </h2>
          <div className="accent-line mt-5" />
          <p className="mt-5 text-navy/75 text-base sm:text-lg">
            Choose the coverage level that fits your needs. All policies include the same trusted protections — only the
            benefit amount changes.
          </p>
        </div>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {PLANS.map((p) => (
            <div
              key={p.amount}
              data-testid={`plan-card-${p.amount.replace(/[^0-9]/g, "")}`}
              className={`relative rounded-xl bg-white border ${p.popular ? "border-[#C5A059]" : "border-border"} p-6 lift-on-hover flex flex-col`}
            >
              {p.popular && (
                <span className="absolute -top-3 left-1/2 -translate-x-1/2 bg-[#0B203B] text-[#E8C97A] text-[11px] tracking-[0.2em] uppercase font-semibold px-3 py-1 rounded-full">
                  Most Chosen
                </span>
              )}
              <p className="text-xs uppercase tracking-[0.18em] text-muted-foreground">Coverage</p>
              <p className="font-serif text-4xl text-navy mt-1">{p.amount}</p>
              <div className="mt-3 flex items-baseline gap-1.5">
                <span className="text-sm text-muted-foreground">from</span>
                <span className="font-serif text-2xl text-[#B08A3E]">{p.starting}</span>
                <span className="text-sm text-muted-foreground">/mo*</span>
              </div>
              <p className="text-sm text-navy/75 mt-3 leading-relaxed flex-1">{p.desc}</p>
              <a
                href="#quote-form"
                data-testid={`plan-cta-${p.amount.replace(/[^0-9]/g, "")}`}
                className="mt-5 inline-flex items-center justify-center h-11 rounded-md bg-[#0B203B] text-white hover:bg-[#152E55] font-semibold text-sm transition-colors"
              >
                Get Quote
              </a>
            </div>
          ))}
        </div>

        <p className="text-xs text-muted-foreground mt-4">*Sample monthly premiums for a healthy 55-year-old non-tobacco user. Your rate depends on age, gender, health, and state.</p>

        <div className="mt-14 rounded-xl border border-border bg-[#FAFAFA] p-8 sm:p-10" data-testid="plans-features-grid">
          <h3 className="font-serif text-2xl sm:text-3xl text-navy">Every plan includes:</h3>
          <div className="mt-6 grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {FEATURES.map((f) => (
              <div key={f} className="flex items-start gap-3">
                <span className="mt-0.5 inline-flex h-6 w-6 items-center justify-center rounded-full bg-[#C5A059]/20">
                  <Check className="h-4 w-4 text-[#B08A3E]" />
                </span>
                <span className="text-navy font-medium">{f}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
